import { capitalize } from 'lodash';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import useMain from '../../hooks/useMain';
import { numberWithCommas } from '../../utils/helpers';
import Image from '../common/image';

function MaxCapModal() {
	const { initData, theme } = useMain();
	const cards = Object.keys(initData.cards).filter((c) => c !== 'white');

	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	return (
		<>
			<div
				onClick={handleShow}
				style={{ cursor: 'pointer' }}>
				<i className='far fa-question-circle'></i>
			</div>

			<Modal
				contentClassName={`bg-${theme}`}
				show={show}
				onHide={handleClose}
				size='lg'
				centered>
				<Modal.Header
					closeVariant={theme === 'dark' ? 'white' : undefined}
					closeButton>
					<Modal.Title className='d-flex aling-items-center'>
						<Image
							height='40px'
							className='me-2'
							fileName={`logo/icon_${theme}.webp`}
						/>
						<span className='fs-2'>Max Cap Rules</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='mt-3 fw-bold fs-5'>Total Max Cap:</div>
					<p>
						Total Max Cap is equal to the sum of MaxCaps of all your cards, plus your
						MMI card's MaxCap.
					</p>
					<div className='table-responsive'>
						<table className='table table-sm myTable text-center'>
							<thead>
								<tr>
									<th>Card</th>
									<th>Type</th>
									<th>Value $</th>
									<th>Max Cap</th>
								</tr>
							</thead>
							<tbody>
								{cards
									.filter((c) => initData.cards[c].sellIsOpen)
									.map((c, key) => (
										<tr key={key}>
											<td>{`${capitalize(c)} Card`}</td>
											<td>{`${capitalize(initData.cards[c].type)}`}</td>
											<td>
												{numberWithCommas(initData.cards[c].min / 1e6)} to{' '}
												{numberWithCommas(initData.cards[c].max / 1e6)}
											</td>
											<td>{initData.cards[c].maxCap}%</td>
										</tr>
									))}
							</tbody>
						</table>
					</div>
					<div className='mt-3 fw-bold fs-5'>When the Max Cap is full:</div>
					<p>When your max cap is filled, you need to buy the package again.</p>
					<ul>
						<li>
							If you upgrade your package before the Max cap is filled, your purchase
							will be combined with the previous purchase and the profit calculation
							rules will change based on the upgraded amount.
						</li>
						<li>
							If you buy a new package after the Max cap is filled, your package value
							will be equal only to your new purchase amount. If your Max cap is
							filled and you want to reinvest, the purchase amount must be equal or
							greater than your last active package.
						</li>
					</ul>
					<div className='mt-3 fw-bold fs-5'>Note:</div>
					<p className='mb-0'>
						When the Max cap is profitable and you don't renew your package, your
						position will turn into a White card. <br />
						In this case, your points and sales of your team becomes zero and the
						following features will be disabled for you:
					</p>
					<ul>
						<li> Internal Exchange</li>
						<li> Internal Transfer</li>
						<li> Early Termination</li>
					</ul>
				</Modal.Body>
				<Modal.Footer className='d-flex justify-content-evenly align-items-center'>
					<button
						onClick={handleClose}
						className={`btn btn-set2-${theme}`}>
						Close
					</button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default MaxCapModal;
